var _path, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconEyeOpen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4 12.0004L3.28211 11.7833L3.21644 12.0004L3.28214 12.2176L4 12.0004ZM20 11.9996L20.7179 12.2167L20.7836 11.9996L20.7179 11.7824L20 11.9996ZM4.71789 12.2175C5.67768 9.04402 8.58148 6.75 12.0001 6.75V5.25C7.88871 5.25 4.424 8.0077 3.28211 11.7833L4.71789 12.2175ZM12.0001 6.75C15.4185 6.75 18.3221 9.04367 19.2821 12.2168L20.7179 11.7824C19.5757 8.00728 16.1112 5.25 12.0001 5.25V6.75ZM19.2821 11.7825C18.3223 14.956 15.4185 17.25 11.9999 17.25V18.75C16.1113 18.75 19.576 15.9923 20.7179 12.2167L19.2821 11.7825ZM11.9999 17.25C8.58151 17.25 5.67789 14.9563 4.71786 11.7832L3.28214 12.2176C4.4243 15.9927 7.88878 18.75 11.9999 18.75V17.25Z",
    fill: "currentColor"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 3,
    stroke: "currentColor",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconEyeOpen);
export default __webpack_public_path__ + "static/media/icon-eye-open.25baddd96917e785554f9773f0c1974f.svg";
export { ForwardRef as ReactComponent };